import { usePackingList } from "@RequestFormV2/sections/PackingList/context";
import { hasContainerHandlingUnit } from "@RequestFormV2/sections/PackingList/utils/buildHandlingUnitHashMap";

export default function useShowContainersSection() {
  const { packingListConfig } = usePackingList();
  return hasContainerHandlingUnit(packingListConfig?.handling_unit_options);
}
